export const getGeoCoords = ({ maximumAge = 3600000 } = {}) => new Promise((resolve, reject) => {
  if (!navigator.geolocation) return resolve();
  navigator.geolocation.getCurrentPosition(({ coords }) => resolve(coords), reject, { maximumAge });
});
